// utils/API/BackendHelper/contact.js
import ApiHelper from '../ApiHelper';
import API_ENDPOINTS from '../endpoints';

/**
 * Contact API Helper
 * Handles the public contact-us form submission.
 */
class ContactHelper {
  /**
   * Submit the contact-us form.
   * @param {Object} payload
   * @param {string} payload.name
   * @param {string} payload.email
   * @param {string} [payload.phone]
   * @param {string} [payload.subject]
   * @param {string} payload.message
   * @param {boolean} payload.privacyAccepted - must be true
   * @returns {Promise<Object>} Standard ApiHelper response
   */
  static async submit(payload) {
    return await ApiHelper.post(API_ENDPOINTS.CONTACT.SUBMIT, payload);
  }
}

export default ContactHelper;
